import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {create} from "../../../app/setters/create.js";

export const useDodajTag = () => {

    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) => create(`/rejestr/tag`, data),
        onError: () => {
            toast.error('Błąd podczas operacji')
        },

        onSettled: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['tagi_lista'],
            });
        },

        onSuccess: ({message}) => {
            toast.success(message)
        }
    })
}